import React from "react";
import { Card } from "./styles";

import ReportsConvenioGrupoView from "../../views/ReportsConvenioGrupo/index.jsx";

export default function HomeConvenioGrupo() {
  return (
    <div>
      <Card>
        <ReportsConvenioGrupoView />
      </Card>
    </div>
  );
}
